// import $ from 'jquery'

export default {
    name: 'examen-clinique',
    components: {},

    props: ['consultation_id', 'is_printable'],
    data() {
        return {
            exam_clinique_loading: true,
            exam_clinique_empty: false,
        }
    },

    watch: {
        consultation_id() {
            console.log(">>> ",this.consultation_id)
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        appareil_examines_historique() {
            return this.$store.getters["appareil_examines_historique"];
        },
    },

    created() {},

    mounted() {
        this.getListeAppareilExamine()
    },

    methods: {
        getListeAppareilExamine() {
            console.log(">>> ",this.consultation_id)
            this.exam_clinique_loading = true
            let data = {
                consultation_id: this.consultation_id,
                protocole_id: 0,
                est_encours: false
            }

            this.$store.dispatch("getTypeAppareilExamines", data).then(() => {
                console.log(">>> exm ",this.appareil_examines_historique)
                if (this.appareil_examines_historique.length > 0) {
                    this.exam_clinique_empty = false
                } else {
                    this.exam_clinique_empty = true
                }

                this.exam_clinique_loading = false
            })
        },
    }
}